import { Injectable } from "@nestjs/common";
import { AssetRequestDto } from "./dto/asset-requisition.dto";
import { AssetRequistion } from "./entity/asset-requisition.entity";

@Injectable()
export class AssetRequistionAdapter {
    public convertDtoToAssetRequestEntity(requestDto: AssetRequestDto, isUpdate: boolean = false): AssetRequistion {
        const assetRequest = new AssetRequistion();

        assetRequest.requestId = requestDto.requestId;
        assetRequest.requestCode = requestDto.requestCode;
        assetRequest.raisedBy = requestDto.raisedBy;
        assetRequest.requestTime = requestDto.requestTime;
        assetRequest.assetCategory = requestDto.assetCategory;
        assetRequest.assetName = requestDto.assetName;
        assetRequest.quantity = requestDto.quantity;
        assetRequest.status = requestDto.status;
        assetRequest.fromPlant = requestDto.fromPlant;
        assetRequest.toPlant = requestDto.toPlant;
        assetRequest.reason = requestDto.reason;
        assetRequest.isActive = requestDto.isActive == undefined ? true : requestDto.isActive;
        return assetRequest;
    
    }

    public convertEntityToDto(request:AssetRequistion) : AssetRequestDto{
        const requestDto = new AssetRequestDto;
        requestDto.requestId = request.requestId;
        requestDto.requestCode = request.requestCode;
        requestDto.raisedBy = request.raisedBy;
        requestDto.requestTime = request.requestTime;
        requestDto.assetCategory = request.assetCategory;
        requestDto.assetName = request.assetName;
        requestDto.quantity = request.quantity;
        requestDto.status = request.status;
        requestDto.fromPlant = request.fromPlant;
        requestDto.toPlant = request.toPlant;
        requestDto.reason = request.reason;
        requestDto.createdAt = request.createdAt;
        requestDto.createdUser = request.createdUser;
        requestDto.isActive = request.isActive;
        requestDto.updatedAt = request.updatedAt;
        requestDto.updatedUser = request.updatedUser;
        requestDto.versionFlag = request.versionFlag;
        return requestDto;
        
    }
}